import { Button, Form, Modal, notification } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { createCategory, getCategories } from "store/slices/categoriesSlice"
import { closeModal } from "store/slices/modalsSlice"
import CategoryForm from "./category-form"

const NewCategoryModal = () => {
  const { t } = useTranslation()
  const [form] = Form?.useForm()
  const dispatch = useDispatch()
  const { isModalOpen, modalType } = useSelector((state) => state?.modals)
  const { loading } = useSelector((state) => state?.categories)

  const open = isModalOpen && modalType === "new_category"

  const onSubmit = async (values) => {
    try {
      // Transformer les sous-catégories pour correspondre à la nouvelle structure
      const transformedValues = {
        titled: values?.titled,
        description: values?.description || undefined,
        subCategories: values?.subCategories
          ? values?.subCategories?.map((subCat) => ({
              titled: subCat?.titled,
              description: subCat?.description || undefined,
            }))
          : [],
        // Vous pouvez ajouter schoolId ici si nécessaire
        // schoolId: values.schoolId
      }

      await dispatch(createCategory(transformedValues))?.unwrap()
      // recharger les catégorie après l'insertion
      await dispatch(getCategories())

      notification?.success({
        message: t("categories.crud.form.success"),
      })
      onClose()
    } catch (error) {
      console?.error("Erreur lors de la création de la catégorie:", error)
      notification?.error({
        message: t("categories.crud.form.error.failed"),
        role: "alert",
        duration: 3,
      })
    }
  }

  const onClose = () => {
    form?.resetFields()
    dispatch(closeModal())
  }

  return (
    <Modal
      title={
        <h4 style={{ textAlign: "center" }}>{t("categories.crud.form")}</h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("categories.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="category_form"
          disabled={loading}
        >
          {t("categories.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <CategoryForm form={form} onSubmit={onSubmit} />
    </Modal>
  )
}

export default NewCategoryModal
